import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithAuth } from '../../../services/api-base';
import type { ContactRequest } from '../../../types/help-support.types';

export const helpSupportApi = createApi({
  reducerPath: 'helpSupportApi',
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    submitContactRequest: builder.mutation<unknown, ContactRequest>({
      query: (body) => ({
        url: '/notification-service/api/v1/notifications',
        method: 'POST',
        body,
      }),
    }),
    submitSalesRequest: builder.mutation<unknown, ContactRequest>({
      query: (body) => ({
        url: '/notification-service/api/v1/salesSubmission',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const {
  useSubmitContactRequestMutation,
  useSubmitSalesRequestMutation,
} = helpSupportApi;
